import PropTypes from 'prop-types';

export default PropTypes.shape({
	userID: PropTypes.string.isRequired,
	contactInfo: PropTypes.shape({
		firstName: PropTypes.string,
		displayName: PropTypes.string,
		lastName: PropTypes.string,
		email: PropTypes.string,
		businessPhone: PropTypes.string,
		cellPhone: PropTypes.string,
		fax: PropTypes.string,
		companyName: PropTypes.string,
		address1: PropTypes.string,
		address2: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		websiteUrl: PropTypes.string
	}),
	logoUrl: PropTypes.string,
	partnerID: PropTypes.string,
	userRole: PropTypes.number,
	emailFooter: PropTypes.string,
	sessionID: PropTypes.string,
	isAdminUser: PropTypes.bool,
	isOfficeUser: PropTypes.bool,
	isEndUser: PropTypes.bool,
	isComplianceUser: PropTypes.bool,
	isUnsupportedUser: PropTypes.bool
});